export class SentryErrorReporter {
    sentry;
    constructor(sentry) {
        this.sentry = sentry;
    }
    capture(error) {
        return this.sentry.captureException(error);
    }
    captureEvent(event) {
        return this.sentry.captureEvent(event);
    }
    async flush(timeoutInMs) {
        return await this.sentry.flush(timeoutInMs);
    }
    addBreadcrumb(breadcrumb) {
        this.sentry.addBreadcrumb(breadcrumb);
    }
    log(message, level) {
        return this.sentry.captureMessage(message, level);
    }
    debug(message) {
        return this.log(message, "debug");
    }
    info(message) {
        return this.log(message, "info");
    }
    warn(message) {
        return this.log(message, "warning");
    }
    error(message) {
        return this.log(message, "error");
    }
    fatal(message) {
        return this.log(message, "fatal");
    }
}
//# sourceMappingURL=index.js.map